import { Meter, MeterLabel, MeterValue } from "@diametral/design-system/react";

import { useTranslation } from "../lib/i18n";
import { trlLabel } from "../lib/reference";

/** Technology Readiness Level 1–9: a meter plus the level's label (EU scale). */
export function TrlMeter({ trl, label, compact = false }: { trl: number; label?: string; compact?: boolean }) {
  const { t } = useTranslation();
  const text = label || trlLabel(trl);
  return (
    <div className="ada-trl" title={text}>
      <Meter value={trl} min={0} max={9} getAriaValueText={() => t("TRL {{trl}} of 9: {{text}}", { trl, text })}>
        <MeterLabel>TRL {trl}</MeterLabel>
        <MeterValue>{() => `${trl}/9`}</MeterValue>
      </Meter>
      {compact ? null : <div className="ada-faint">{text}</div>}
    </div>
  );
}
